<template>
  <table class="gvnts-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Игровое<br>событие</th>
        <th scope="col">Тип</th>
        <th scope="col">Начало</th>
        <th scope="col">Начало реальное</th>
        <th scope="col">Конец</th>
        <th scope="col">
          Количество<br>полученных<br>наград
        </th>
        <th scope="col" v-if="isActionsColumnVisible">Действия</th>
      </tr>
    </thead>
    <tr
      v-for="gvnt in gvnts"
      :key="gvnt.gvntId"
    >
      <td>
        <gvnt-link :gvntId="gvnt.gvntId" label=""/>
      </td>
      <td>
        {{ gvnt.gvntType | getGvntTypeName }}
      </td>
      <td>
        {{ gvnt.stime | getMomentStr }}
      </td>
      <td>
        {{ gvnt.srtime | getMomentStr }}
      </td>
      <td>
        {{ gvnt.ftime | getMomentStr }}
      </td>
      <td class="text-right">
        {{ gvnt.progressRewardsClaimed | getFormattedNumber }}
      </td>
      <td v-if="isActionsColumnVisible" class="action-box">
        <b-button
          v-if="isFinishButtonVisible(gvnt)"
          @click="finishGvnt(gvnt)"
          variant="warning"
          size="sm"
        >
          Завершить
        </b-button>
      </td>
    </tr>
  </table>
</template>

<script>
import auth from '../auth.js';

import { getGvntTypeName    } from '../model/gvnt.js';
import { isPlayerGvntActive } from '../model/gvnt.js';

import { mayEditPlayerData } from '../model/player.js';

import GvntLink from './GvntLink.vue';

export default {
  name: 'PlayerGvntsTable',

  components: {
    GvntLink,
  },

  data() {
    return {
      actor: auth.getViewer(),
    };
  },

  props: {
    gvnts: {
      type: Array,
      required: true,
    },
  },

  computed: {
    /** @returns {boolean} */
    isActionsColumnVisible() {
      if(!this.mayEditPlayerData) {
        return false;
      }

      return this.hasGvntToFinish;
    },

    /** @returns {boolean} */
    mayEditPlayerData() {
      return mayEditPlayerData(this.actor.role);
    },

    /** @returns {boolean} */
    hasGvntToFinish() {
      return this.hasActiveGvnt;
    },

    /** @returns {boolean} */
    hasActiveGvnt() {
      for(const gvnt of this.gvnts) {
        if(isPlayerGvntActive(gvnt.ftime)) {
          return true;
        }
      }
      return false;
    },
  },

  methods: {
    isFinishButtonVisible(gvnt) {
      if(!this.mayEditPlayerData) {
        return false;
      }
  
      return isPlayerGvntActive(gvnt.ftime);
    },

    finishGvnt(gvnt) {
      this.$emit('gvnt-finish-requested', gvnt);
    },
  },

  filters: {
    getGvntTypeName,
  },
}
</script>

<style scoped>
.gvnts-table {
  width: 1px;
}

.action-box {
  padding: 7px;
  vertical-align: middle;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
